import { isFieldError } from "../helpers";

import Input from "../components/Input";
import RadiosScale from "../components/RadiosScale";

export default function Q4Fields({ handleUpdate, errors }) {
	return (
		<>
			<h4 style={{ fontSize: "1.15rem" }}>4. Gifting Process</h4>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="4.1 How easy was it to submit, track, and manage gifting information for your attendees?"
					reqd={true}
					data={[
						{
							name: "q4_1",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q4_1",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q4_1",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q4_1",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q4_1",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q4_1") ? true : false}
				/>
			</div>

			<div
				className="form-group radios"
				style={{ marginTop: "15px", marginBottom: "0" }}
			>
				<RadiosScale
					label="4.2 How clear were the gifting options, deadlines, and expectations?"
					reqd={true}
					data={[
						{
							name: "q4_2",
							val: "1",
							label: "1 - Poor",
						},
						{
							name: "q4_2",
							val: "2",
							label: "2 - Fair",
						},
						{
							name: "q4_2",
							val: "3",
							label: "3 - Good",
						},
						{
							name: "q4_2",
							val: "4",
							label: "4 - Very Good",
						},
						{
							name: "q4_2",
							val: "5",
							label: "5 - Excellent",
						},
					]}
					value={""}
					click={handleUpdate}
					error={isFieldError(errors, "q4_2") ? true : false}
				/>
			</div>

			<div className="form-group one " style={{ marginTop: "15px" }}>
				<Input
					name="q4_3"
					label="4.3 What feedback or suggestions do you have regarding the gifting process?"
					reqd={true}
					value={""}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>
		</>
	);
}
